import {useQuery} from '@tanstack/react-query'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import {useCommerceApi, useAccessToken} from '@salesforce/commerce-sdk-react'

const useSiteCategories = ({parameters}, {enabled = Boolean(parameters.ids)} = {}) => {
    const api = useCommerceApi()
    const {getTokenWhenReady} = useAccessToken()

    const getCategories = async (parameters) => {
        try {
            const token = await getTokenWhenReady()
            const categories = await api.shopperProducts.getCategories({
                parameters: parameters,
                headers: {
                    Authorization: `Bearer ${token}`
                },
                keepPreviousData: true
            })

            return categories
        } catch (error) {
            logger.error('Error fetching Site Categories', {
                namespace: 'useSiteCategories.getCategories',
                additionalProperties: {error}
            })
            throw error
        }
    }

    return useQuery({
        enabled,
        queryKey: ['use-site-categories', parameters],
        queryFn: () => getCategories(parameters),
        keepPreviousData: true,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false
    })
}

export default useSiteCategories
